import React, { useState, useEffect } from "react";
import { InputModal } from "./Modal";
// import TreeContainer from "./TreeContainer";
// import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "./NoteNav.css";
// import Spinner from "../Spinner";
// import SvgNoteIcon from "../icons/iconComponents/NoteIcon";
// import SvgBookmark from "../icons/iconComponents/Bookmark";
// import SvgNewFolderIcon from "../icons/iconComponents/NewFolderIcon";
// import SvgAddIcon from "../icons/iconComponents/AddIcon";
import ReactTooltip from "react-tooltip";
import { commitLocalUpdate } from "react-relay";
import environment, { updateLocalSetting } from "../Environment";
// import SvgNoteViewIcon from "../icons/iconComponents/NoteViewIcon";
import NoteViewContainer from "../components/NoteViewContainer";
import { useTheme } from "../contexts/ThemeContext";

function NoteNav(props) {
	let [isModalActive, setIsModalActive] = useState(false);
	const navigate = useNavigate();
	const [isNoteView, setIsNoteView] = useState(false);
	const [isBookmarkView, setIsBookmarkView] = useState(false);
	const [isTreeView, setIsTreeView] = useState(false);
	const [isNotes, setIsNotes] = useState(false);
	const theme = useTheme();

	const { isNoteViewActivated, isDetailView } = props.settings;
	const { is_premium, payment_status } = props.user;

	function onAddSourceClick(e) {
		e.preventDefault();
		navigate("/add-source");
	}

	function onAllSourcesClick(e) {
		e.preventDefault();
	}

	function onCreateFeedClick(e) {
		e.preventDefault();
		setIsModalActive(true);
	}

	function onNoteViewClick(e) {
		e.preventDefault();
		setIsNoteView(!isNoteView);
		setIsBookmarkView(false);

		// props.setIsActivated(!props.isActivated);
		commitLocalUpdate(environment, store => {
			const record = store.getRoot().getLinkedRecord("settings");
			record.setValue(!isNoteViewActivated, "isNoteViewActivated");
		});
		// updateLocalSetting("isNoteViewActivated", !props.isNoteViewActivated);
	}

	function onBookmarkClick(e) {
		e.preventDefault();
		setIsBookmarkView(true);
		setIsNoteView(false);
	}

	function onUpgradeMessageClick(e) {
		e.preventDefault();
		navigate("/upgrade");
	}

	let navbarState = props.isActivated ? "open" : "closed";


    let premiumOrTrial = false;
    if (payment_status === "active" || payment_status === "trialing") {
       premiumOrTrial = true;
    } else if (payment_status === "past_due") {
        premiumOrTrial = false;
    } else {
        premiumOrTrial = false;
    }

	return (
		<div
			id="mySidebar"
			className={`theme-${theme.dark} sidebar-note nav-${navbarState}`}
		>
			<ReactTooltip delayShow={400} backgroundColor="#626262" />
			<div className={`sidenav-content`}>
				<div className={`sidenav-items`}>
					<div
						className={`sidenav-main-categories sidenav-group`}
					></div>

					<div className="note-container">
						<h3 className={`theme-${theme.paragraph}`}> Notes </h3>
						{premiumOrTrial ? (
							<div>
								<NoteViewContainer
									postId={props.postId}
									user={props.user}
									settings={props.settings}
								/>
							</div>
						) : (
							<div>
								{" "}
									<p className={`upgrade-message theme-${theme.paragraph}`}>
										{
											"You have no notes yet. To add notes, "
										}{" "}
										<button onClick={onUpgradeMessageClick}
											className={`theme-${theme.link} link-button`}
										>
											{" "}
											Upgrade to Premium
										</button>{" "}
									</p>
							</div>
						)}
					</div>
					{isModalActive ? (
						<div>
							<InputModal
								title="Create a new Category"
								setIsModalActive={setIsModalActive}
								isModalActive={isModalActive}
							/>
						</div>
					) : null}
				</div>
			</div>
			{/*
			
			<div className={`source-add-btn-container`}>

				{isDetailView ? (
					<SvgNoteViewIcon size="1.7rem" onClick={onNoteViewClick} />
				) : (
					<SvgNoteIcon data-tip="Posts with Notes" size="1.7rem" />
				)}
			</div>
			
			*/}
		</div>
	);
}

export default NoteNav;
